import { NgModule } from '@angular/core';
import { SharedModule } from 'app/core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { TodoDetailsComponent } from './todo-details/todo-details.component';
import { TodoListComponent } from './todo-list/todo-list.component';
import { TodoService } from './todo.service';
import { TodoSideNavComponent } from './todo-side-nav/todo-side-nav.component';
import { ImportantComponent } from './components/important/important.component';
import { MyDayComponent } from './components/my-day/my-day.component';
import { PlannedComponent } from './components/planned/planned.component';
import { MyDaySidenavComponent } from './components/my-day-sidenav/my-day-sidenav.component';
import { PriorityComponent } from './components/priority/priority.component';
import { TodoRoutingModule } from './todo-routing.module';
import { SettingsSideNavComponent } from './components/settings-side-nav/settings-side-nav.component';
import { TodoCommentsComponent } from './components/todo-comments/todo-comments.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { FormsModule } from '@angular/forms';
import { ShareListComponent } from './components/share-list/share-list.component';
import { AssignedToMeComponent } from './components/assigned-to-me/assigned-to-me.component';
import { UserSelecterComponent } from './components/user-selecter/user-selecter.component';
import { TodoUploaderComponent } from './components/todo-uploader/todo-uploader.component';


const components = [
  TodoDetailsComponent,
  TodoListComponent,
  TodoSideNavComponent,
  ImportantComponent,
  MyDayComponent,
  PlannedComponent,
  MyDaySidenavComponent,
  PriorityComponent,
  SettingsSideNavComponent,
  TodoCommentsComponent,
  ShareListComponent,
  AssignedToMeComponent,
  UserSelecterComponent,
  TodoUploaderComponent
]

@NgModule({
  entryComponents: [ShareListComponent],
  imports: [
    SharedModule,
    TodoRoutingModule,
    AngularMultiSelectModule,
    FormsModule

  ],
  declarations: [...components],
  providers: [TodoService],
  exports: [TodoListComponent, TodoDetailsComponent, UserSelecterComponent]
})
export class TodoTabModule { }



// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/todo-tab.module.ts